(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Howtestkitworks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.shopify-section--welbewust-how-it-works');
    if (!section) {
      return;
    }
    const animatedElements = section.querySelectorAll('.animate-on-scroll');
    if (animatedElements.length === 0) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: 0.2,
      }
    );
    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Magnesium-benifits"] && !Shopify.designMode) return;
  try {
    
  const initBenefitsObserver = () => {
    const section = document.querySelector('.proven-benefits-section-final');
    if (!section) return;
    
    if (section._benefitsObserver) {
      section._benefitsObserver.disconnect();
      section._benefitsObserver = null;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          section.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
    section._benefitsObserver = observer;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitsObserver);
  } else {
    initBenefitsObserver();
  }

  document.addEventListener('shopify:section:load', initBenefitsObserver);
  document.addEventListener('shopify:section:unload', initBenefitsObserver);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Magnesium-calm"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('[data-section-id]');

    sections.forEach((section) => {
      const sectionId = section.getAttribute('data-section-id');

      if (sectionId === '123') {
        section.style.backgroundColor = 'lightblue';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Magnesium-two"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sectionSelector = `.related-products-section[data-section-id]`;

  const setLoading = (btn, isLoading) => {
    if (isLoading) {
      if (!btn.dataset.originalHtml) btn.dataset.originalHtml = btn.innerHTML;
      btn.innerHTML = `
        <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2" aria-hidden="true">
          <circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-linecap="round"></circle>
          <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.9s" repeatCount="indefinite"/>
        </svg>
      `;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.innerHTML = btn.dataset.originalHtml || btn.innerHTML;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  };

  // One delegated listener handles all current/future buttons in this section
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card-button');
    if (!btn) return;

    // Ensure the button belongs to THIS section instance
    const root = btn.closest(sectionSelector);
    if (!root) return;

    // Ignore unavailable products
    if (btn.dataset.available !== 'true') return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.dataset.loading === 'true') return;
    btn.dataset.loading = 'true';

    const variantId = btn.dataset.variantId;
    if (!variantId) {
      btn.dataset.loading = 'false';
      return;
    }

    setLoading(btn, true);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId) || variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error(`Add to cart failed (${res.status})`);

      btn.innerHTML = '✓';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      setTimeout(() => {
        setLoading(btn, false);
        btn.dataset.loading = 'false';
      }, 1200);
    } catch (err) {
      console.error('Error adding to cart:', err);
      btn.innerHTML = '!';
      setTimeout(() => {
        setLoading(btn, false);
        btn.dataset.loading = 'false';
      }, 1200);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Magnesium-usage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const animationGroups = document.querySelectorAll('.animation-group');
    if (!animationGroups.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    animationGroups.forEach((group) => {
      observer.observe(group);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Personalizedplan"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AOS_URL = 'https://unpkg.com/aos@2.3.1/dist/aos.js';
    let loading;

    const ensureAOS = () => {
      if (window.AOS) return Promise.resolve(window.AOS);
      if (!loading) {
        loading = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = AOS_URL;
          s.async = true;
          s.onload = () => resolve(window.AOS);
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      return loading;
    };

    const initAOS = () => {
      if (!window.AOS) return;
      window.AOS.init({
        duration: 800,
        easing: 'ease-in-out',
        once: false, // animate again when scrolling back
        mirror: true, // animate out on scroll past
        anchorPlacement: 'top-bottom',
      });
    };

    const boot = () =>
      ensureAOS()
        .then(() => {
          initAOS();
          // Recalculate in case content was added before init
          window.AOS.refreshHard && window.AOS.refreshHard();
        })
        .catch(() => {
          /* fail silently */
        });

    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', () => window.AOS && window.AOS.refresh());
    document.addEventListener('shopify:section:unload', () => window.AOS && window.AOS.refresh());
    window.addEventListener('resize', () => window.AOS && window.AOS.refresh());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-us-experts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.aboutus-experts-section');
    const track = document.querySelector('.experts-grid');
    if (!wrapper || !track) return;

    const { gsap, ScrollTrigger } = window;
    if (!gsap || !ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);

    const isMobile = matchMedia('(max-width: 767px)').matches;

    if (isMobile) {
      // === Mobile layout (no scroll animation) ===
      Object.assign(track.style, {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: '0.75rem',
        overflow: 'visible',
      });

      const slides = Array.from(track.children).filter((el) =>
        el.classList.contains('expert-rect')
      );
      slides.forEach((s) => {
        s.style.flex = '0 0 clamp(70%, 80vw, 320px)';
        s.style.height = '180px';
      });

      track.querySelectorAll('.fade-in, .fade-out').forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });

      return; // skip desktop animation
    }

    // === Desktop: trigger animation when section enters view ===
    const allImgs = gsap.utils.toArray('.expert-img');
    const rects = gsap.utils.toArray('.expert-rect');
    const mid = window.innerWidth / 2;
    const leftRects = [];
    const rightRects = [];

    rects.forEach((r) => {
      const bounds = r.getBoundingClientRect();
      const center = bounds.left + bounds.width / 2;
      (center < mid ? leftRects : rightRects).push(r);
    });

    // Initial states
    gsap.set('.expert-word', { opacity: 0, y: 20 });
    gsap.set(leftRects, { opacity: 0, x: '-120%' });
    gsap.set(rightRects, { opacity: 0, x: '120%' });
    gsap.set(allImgs, { opacity: 0, y: 20 });

    // Animation timeline
    const tl = gsap.timeline({ paused: true });

    tl.to('.expert-word', {
      opacity: 1,
      y: 0,
      stagger: 0.2,
      duration: 0.8,
      ease: 'power2.out',
    })
      .to(
        leftRects,
        {
          x: 0,
          opacity: 1,
          stagger: 0.08,
          duration: 1,
          ease: 'power2.out',
        },
        '<50%'
      )
      .to(
        rightRects,
        {
          x: 0,
          opacity: 1,
          stagger: 0.08,
          duration: 1,
          ease: 'power2.out',
        },
        '<'
      )
      .to(
        allImgs,
        {
          opacity: 1,
          y: 0,
          stagger: 0.08,
          duration: 0.6,
          ease: 'power2.out',
        },
        '>'
      );

    // ScrollTrigger: replay when entering from top or bottom
    ScrollTrigger.create({
      trigger: wrapper,
      start: 'top 80%',
      end: 'bottom 20%',
      // Remove `once: true` so it can fire multiple times
      onEnter: () => tl.restart(),      // scrolling down into section
      onEnterBack: () => tl.restart(),  // scrolling back up into section
      onLeave: () => tl.pause(0),       // reset when leaving at bottom
      onLeaveBack: () => tl.pause(0),   // reset when leaving at top
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutus-missions"] && !Shopify.designMode) return;
  try {
    
  // Get all grid cards, the content title, and content text elements.
  const gridItems = document.querySelectorAll('.mission-grid-item');
  const contentTitle = document.getElementById('mission-content-title');
  const contentText = document.getElementById('mission-content-text');

  // Loop through each card/tab
  gridItems.forEach((item) => {
    item.addEventListener('click', function () {
      // Remove 'active' class from all cards, add to the clicked one
      gridItems.forEach((i) => i.classList.remove('active'));
      item.classList.add('active');

      // Get title/content from data attributes
      const tabTitle = item.getAttribute('data-title');
      const tabContent = item.getAttribute('data-content');

      // Update left-side content
      if (contentTitle && tabTitle) {
        contentTitle.textContent = tabTitle;
      }
      if (contentText && tabContent) {
        contentText.textContent = tabContent;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutus-partner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const mqReduced = matchMedia('(prefers-reduced-motion: reduce)');
    const isRTL = () =>
      (document.documentElement.dir || getComputedStyle(document.documentElement).direction) === 'rtl';

    const debounce = (fn, delay = 160) => {
      let t;
      return (...a) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...a), delay);
      };
    };

    // Build one carousel inside a given scope (a section root)
    function initOne(scope) {
      const root = scope && scope.querySelector ? scope : document;

      // Prefer data-attributes; fall back to legacy id patterns inside this root
      const carousel = root.querySelector('[data-partners-carousel], [id^="partner-carousel-"]');
      const track = root.querySelector('[data-logos-track], [id^="logos-track-"]');
      if (!carousel || !track) return;

      const SPEED = 60; // px per second
      const dir = isRTL() ? 1 : -1; // move toward inline-start
      let offset = 0;
      let halfWidth = 0;
      let rafId = 0;

      // Wait for images so widths are correct
      const waitImages = () => {
        const imgs = track.querySelectorAll('img');
        if (!imgs.length) return Promise.resolve();
        let done = 0;
        return new Promise((resolve) => {
          const next = () => ++done >= imgs.length && resolve();
          imgs.forEach((img) => {
            if (img.complete) next();
            else {
              img.addEventListener('load', next, { once: true });
              img.addEventListener('error', next, { once: true }); // don’t block
            }
          });
        });
      };

      const duplicateUntilOverflow = () => {
        // Remove previous clones
        track.querySelectorAll('[data-clone="true"]').forEach((n) => n.remove());

        const children = Array.from(track.children);
        if (!children.length) return;

        // Ensure seamless loop: at least ~2× container width
        while (track.scrollWidth < carousel.offsetWidth * 2) {
          children.forEach((child) => {
            const clone = child.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.dataset.clone = 'true';
            track.appendChild(clone);
          });
        }
        halfWidth = track.scrollWidth / 2;
      };

      const animate = () => {
        let last = 0;
        const tick = (t) => {
          rafId = requestAnimationFrame(tick);
          if (!last) {
            last = t;
            return;
          }
          const dt = (t - last) / 1000;
          last = t;

          // pause if reduced motion
          const delta = mqReduced.matches ? 0 : dir * SPEED * dt;
          offset += delta;

          // wrap seamlessly at half width (original content width)
          if (dir < 0 && offset <= -halfWidth) offset += halfWidth;
          if (dir > 0 && offset >= halfWidth) offset -= halfWidth;

          track.style.transform = `translateX(${offset}px)`;
        };
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(tick);
      };

      const stop = () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
      };
      const play = () => {
        if (!rafId) animate();
      };

      const reset = () => {
        stop();
        offset = 0;
        track.style.transform = 'translateX(0)';
        duplicateUntilOverflow();
        play();
      };

      const onVisibility = () => (document.hidden ? stop() : play());

      // ResizeObserver keeps loop seamless on layout changes
      const ro = new ResizeObserver(debounce(reset, 120));
      ro.observe(carousel);

      // Interactions: pause on hover/focus for accessibility
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', play);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', play);
      document.addEventListener('visibilitychange', onVisibility);

      // Boot
      waitImages().then(() => {
        duplicateUntilOverflow();
        if (!mqReduced.matches) play();
      });

      // Return disposer so Theme Editor can clean up
      return () => {
        stop();
        ro.disconnect();
        carousel.removeEventListener('mouseenter', stop);
        carousel.removeEventListener('mouseleave', play);
        carousel.removeEventListener('focusin', stop);
        carousel.removeEventListener('focusout', play);
        document.removeEventListener('visibilitychange', onVisibility);
      };
    }

    // Live site
    document.addEventListener('DOMContentLoaded', () => {
      // Prefer scoping to the nearest section for this script
      const host = document.currentScript?.closest('.partners-carousel');
      if (host) initOne(host);
      else initOne(document);
    });

    // Theme Editor
    document.addEventListener('shopify:section:load', (e) => {
      if (!e.target) return;
      // Only initialize sections that actually contain the carousel markup
      if (e.target.matches('.partners-carousel') || e.target.querySelector('[data-partners-carousel]')) {
        // store disposer on the element to avoid duplicates
        e.target.__disposePartners?.();
        e.target.__disposePartners = initOne(e.target);
      }
    });
    document.addEventListener('shopify:section:unload', (e) => {
      e.target?.__disposePartners?.();
      e.target.__disposePartners = null;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aboutus-value"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;

    const { gsap, ScrollTrigger } = window;
    gsap.registerPlugin(ScrollTrigger);

    const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const dir = (document.documentElement.dir || getComputedStyle(document.documentElement).direction) || 'ltr';
    const rtl = dir.toLowerCase() === 'rtl';
    const inlineStart = rtl ? 'right' : 'left';

    const items = gsap.utils.toArray('.value-item');

    items.forEach((item) => {
      const dot  = item.querySelector('.timeline-dot');
      const line = item.querySelector('.timeline-line');

      // Initial state
      if (dot) gsap.set(dot,  { backgroundColor: '#e5e7eb', borderColor: '#d1d5db' });
      if (line) {
        // Orientation: default vertical (scaleY). For horizontal lines, add data-orient="x" or class "is-horizontal"
        const isHorizontal = line.dataset.orient === 'x' || line.classList.contains('is-horizontal');

        if (isHorizontal) {
          gsap.set(line, { backgroundColor: '#e5e7eb', scaleX: 0, transformOrigin: `center ${inlineStart}` });
        } else {
          gsap.set(line, { backgroundColor: '#e5e7eb', scaleY: 0, transformOrigin: 'top center' });
        }
      }

      if (prefersReduced) {
        // Respect reduced motion: jump to "on" state when in view once
        ScrollTrigger.create({
          trigger: item,
          start: 'top center+=100',
          onEnter: () => {
            if (dot)  gsap.set(dot,  { backgroundColor: '#E94E1A', borderColor: '#E94E1A' });
            if (line) {
              const isHorizontal = line.dataset.orient === 'x' || line.classList.contains('is-horizontal');
              gsap.set(line, { backgroundColor: '#E94E1A', ...(isHorizontal ? { scaleX: 1 } : { scaleY: 1 }) });
            }
          },
          once: true
        });
        return;
      }

      // Animations (play on enter, reverse on leave)
      if (dot) {
        gsap.to(dot, {
          backgroundColor: '#E94E1A',
          borderColor: '#E94E1A',
          ease: 'none',
          scrollTrigger: {
            trigger: item,
            start: 'top center+=100',
            toggleActions: 'play none none reverse'
          }
        });
      }

      if (line) {
        const isHorizontal = line.dataset.orient === 'x' || line.classList.contains('is-horizontal');
        gsap.to(line, {
          backgroundColor: '#E94E1A',
          ...(isHorizontal ? { scaleX: 1 } : { scaleY: 1 }),
          transformOrigin: isHorizontal ? `center ${inlineStart}` : 'top center',
          ease: 'none',
          scrollTrigger: {
            trigger: item,
            start: 'top center+=100',
            toggleActions: 'play none none reverse'
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-section-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const TAU = Math.PI * 2;

    const initOrbit = (orbit) => {
      if (!orbit) return;
      const cards = Array.from(orbit.querySelectorAll('.orbit-card'));
      if (cards.length < 3) return;

      const computeRadius = () => {
        const rect = orbit.getBoundingClientRect();
        const sampleW = cards[0].getBoundingClientRect().width || 130;
        return Math.max(70, Math.min(rect.width, rect.height) / 2 - sampleW / 2 - 8);
      };

      let radius = computeRadius();
      const onResize = () => {
        radius = computeRadius();
      };
      window.addEventListener('resize', onResize, { passive: true });

      const n = cards.length;
      const stepDeg = 360 / n;
      const offsetDeg = -90;
      let anglesDeg = cards.map((_, i) => offsetDeg + i * stepDeg);

      let baseDeg = 0;
      const spinSpeedDegPerSec = 10;
      let rafId, last;

      const apply = () => {
        const baseRad = (baseDeg * Math.PI) / 180;
        cards.forEach((card, i) => {
          const aDeg = anglesDeg[i];
          const aRad = (aDeg * Math.PI) / 180;
          const angle = aRad + baseRad;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          card.style.transform = `translate(-50%,-50%) translate(${x}px,${y}px) rotate(${-(aDeg + baseDeg)}deg)`;
        });
      };

      const tick = (ts) => {
        if (last != null) {
          const dt = (ts - last) / 1000;
          baseDeg = (baseDeg + spinSpeedDegPerSec * dt) % 360;
          apply();
        }
        last = ts;
        rafId = requestAnimationFrame(tick);
      };

      const swapTwo = () => {
        if (cards.length < 2) return;
        let i = (Math.random() * cards.length) | 0;
        let j = (Math.random() * cards.length) | 0;
        if (i === j) j = (j + 1) % cards.length;
        [anglesDeg[i], anglesDeg[j]] = [anglesDeg[j], anglesDeg[i]];
        apply();
      };

      apply();
      rafId = requestAnimationFrame(tick);

      const ms = Math.max(1500, parseInt(orbit.dataset.swapInterval || '3500', 10));
      let swapTimer = setInterval(swapTwo, ms);

      orbit.addEventListener('mouseenter', () => {
        clearInterval(swapTimer);
      });
      orbit.addEventListener('mouseleave', () => {
        swapTimer = setInterval(swapTwo, ms);
      });
    };

    document.querySelectorAll('.avatar-orbit').forEach(initOrbit);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["articles-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Avoid double-init across dynamic Shopify loads
  window._evbArticleCarousels = window._evbArticleCarousels || new Set();

  function initEvbCarousels(context = document) {
    const sections = context.querySelectorAll('[data-article-carousel]');

    sections.forEach((sec) => {
      const id = sec.getAttribute('data-section-id') || Math.random().toString(36).slice(2);
      if (window._evbArticleCarousels.has(id)) return;

      const viewport = sec.querySelector('.evb-viewport');
      const track    = sec.querySelector('.evb-track');
      const slides   = track ? Array.from(track.querySelectorAll('.evb-slide')) : [];
      const prevBtn  = sec.querySelector('.evb-prev');
      const nextBtn  = sec.querySelector('.evb-next');

      if (!viewport || !track || !slides.length || !prevBtn || !nextBtn) return;

      let pageOffsets = [];
      let pageIndex   = 0;
      let pagesCount  = 0;

      const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));

      // How many slides fit fully in the viewport (based on current CSS layout)
      function slidesPerView() {
        if (slides.length <= 1) return Math.max(0, slides.length);
        const vpRect = viewport.getBoundingClientRect();
        const first  = slides.find(el => !el.hasAttribute('hidden')) || slides[0];
        const firstRect = first.getBoundingClientRect();
        let count = 0;
        for (let i = 0; i < slides.length; i++) {
          const r = slides[i].getBoundingClientRect();
          const fullyInside = (r.right - firstRect.left) <= (vpRect.width + 1);
          if (fullyInside) count++; else break;
        }
        return Math.max(1, count);
      }

      function updateNavState() {
        const atStart = pageIndex <= 0 || pagesCount === 0;
        const atEnd   = pagesCount === 0 || pageIndex >= pagesCount - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
        prevBtn.setAttribute('aria-disabled', String(atStart));
        nextBtn.setAttribute('aria-disabled', String(atEnd));
      }

      function computePages(targetFirstIndex = 0) {
        const spv = Math.max(1, slidesPerView());

        // Handle empty just in case
        if (slides.length === 0) {
          pagesCount  = 0;
          pageOffsets = [0];
          pageIndex   = 0;
          viewport.scrollLeft = 0;
          updateNavState();
          return;
        }

        pagesCount  = Math.ceil(slides.length / spv);
        pageOffsets = [];

        const trackLeft = track.getBoundingClientRect().left;
        for (let p = 0; p < pagesCount; p++) {
          const firstIdx = p * spv;
          const slide    = slides[firstIdx];
          const left     = slide.getBoundingClientRect().left - trackLeft + viewport.scrollLeft;
          pageOffsets.push(Math.round(left));
        }

        pageIndex = clamp(targetFirstIndex, 0, Math.max(0, pagesCount - 1));
        scrollToPage(pageIndex, false);
        updateNavState();
      }

      function scrollToPage(i, smooth = true) {
        if (!pageOffsets.length) {
          viewport.scrollLeft = 0;
          updateNavState();
          return;
        }
        const target = pageOffsets[clamp(i, 0, pagesCount - 1)];
        if (typeof viewport.scrollTo === 'function' && smooth) {
          viewport.scrollTo({ left: target, behavior: 'smooth' });
        } else {
          viewport.scrollLeft = target;
        }
        pageIndex = clamp(i, 0, pagesCount - 1);
        updateNavState();
      }

      // Buttons
      prevBtn.addEventListener('click', () => {
        if (!prevBtn.disabled) scrollToPage(pageIndex - 1, true);
      });
      nextBtn.addEventListener('click', () => {
        if (!nextBtn.disabled) scrollToPage(pageIndex + 1, true);
      });

      // Keep pageIndex in sync when user drags/scrolls
      let rafId = null;
      viewport.addEventListener('scroll', () => {
        if (!pageOffsets.length) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const x = viewport.scrollLeft;
          let nearest = 0, min = Infinity;
          for (let i = 0; i < pageOffsets.length; i++) {
            const d = Math.abs(x - pageOffsets[i]);
            if (d < min) { min = d; nearest = i; }
          }
          if (nearest !== pageIndex) {
            pageIndex = nearest;
            updateNavState();
          }
        });
      }, { passive: true });

      // Recompute on resize / image load
      const onResize = () => computePages(pageIndex);
      const ro = window.ResizeObserver ? new ResizeObserver(() => onResize()) : null;
      ro && ro.observe(viewport);
      slides.forEach(slide => {
        const img = slide.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', onResize, { once: true });
      });
      window.addEventListener('resize', onResize, { passive: true });

      // Init
      viewport.scrollLeft = 0;
      computePages(0);

      // Mark initialized
      window._evbArticleCarousels.add(id);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initEvbCarousels());
  document.addEventListener('shopify:section:load',  (e) => initEvbCarousels(e.target));
  document.addEventListener('shopify:section:select',(e) => initEvbCarousels(e.target));
  document.addEventListener('shopify:section:unload',(e) => {
    const sec = e.target.querySelector('[data-article-carousel]');
    if (!sec) return;
    const id = sec.getAttribute('data-section-id');
    if (id) window._evbArticleCarousels.delete(id);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["basic-sleep-hygiens"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('sleep-essentials');
    if (!root) return;

    const pills = Array.from(root.querySelectorAll('.sleep-tabs .sleep-pill'));
    const panels = Array.from(root.querySelectorAll('.sleep-panels .sleep-panel'));
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // --- tiny animation utilities (Web Animations API) ---
    const cancelAnims = (el) => {
      try {
        el.getAnimations?.forEach((a) => a.cancel());
      } catch (_) {}
    };

    const popPill = (el, duration = 280) => {
      if (prefersReduced || !el) return;
      cancelAnims(el);
      el.classList.add('sleep-animate');
      el.animate(
        [
          { transform: 'translateY(0) scale(1)', opacity: 0.9, filter: 'saturate(0.95)' },
          { transform: 'translateY(-2px) scale(1.06)', opacity: 1, offset: 0.6 },
          { transform: 'translateY(0) scale(1)', opacity: 1, filter: 'saturate(1)' },
        ],
        { duration, easing: 'cubic-bezier(.2,.7,.2,1)' }
      );
    };

    const fadeUp = (el, { delay = 0, y = 12, duration = 420 } = {}) => {
      if (prefersReduced || !el) return;
      cancelAnims(el);
      el.classList.add('sleep-animate');
      el.animate(
        [
          { opacity: 0, transform: `translateY(${y}px)` },
          { opacity: 1, transform: 'translateY(0)' },
        ],
        { delay, duration, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' }
      );
    };

    const animatePanelIn = (panel) => {
      if (!panel) return;
      fadeUp(panel.querySelector('.sleep-panel-head'), { delay: 40, y: 10, duration: 360 });
      fadeUp(panel.querySelector('.sleep-panel-body'), { delay: 100, y: 12, duration: 420 });
      fadeUp(panel.querySelector('.sleep-columns'), { delay: 120, y: 12, duration: 420 });
      panel.querySelectorAll('.sleep-list-item').forEach((li, i) => {
        fadeUp(li, { delay: 160 + i * 40, y: 6, duration: 300 });
      });
    };

    // --- tab activation logic (keeps your ARIA behavior) ---
    const clearActive = () => {
      pills.forEach((el) => {
        el.classList.remove('is-active', 'is-initial');
        el.setAttribute('aria-selected', 'false');
      });
      panels.forEach((el) => {
        el.classList.remove('is-active');
        el.setAttribute('hidden', 'hidden');
      });
    };

    const activatePanel = (panel) => {
      if (!panel) return;
      clearActive();
      panel.classList.add('is-active');
      panel.removeAttribute('hidden');

      const id = '#' + panel.id;
      const pill = pills.find((a) => a.getAttribute('href') === id);
      if (pill) {
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        pill.focus({ preventScroll: true });
        popPill(pill);
      }

      animatePanelIn(panel);
    };

    // Clicks + keyboard
    pills.forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const target = root.querySelector(a.getAttribute('href'));
        if (target) activatePanel(target);
      });

      a.addEventListener('keydown', (e) => {
        const current = pills.indexOf(e.currentTarget);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          pills[(current + 1) % pills.length]?.focus();
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          pills[(current - 1 + pills.length) % pills.length]?.focus();
        }
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          a.click();
        }
      });
    });

    // Handle hash navigation
    const tryHash = () => {
      const h = window.location.hash;
      if (!h) return false;
      const target = root.querySelector(h);
      if (target && panels.includes(target)) {
        activatePanel(target);
        return true;
      }
      return false;
    };

    // Initial state
    if (!tryHash()) {
      if (panels[0]) activatePanel(panels[0]);
    }

    window.addEventListener('hashchange', tryHash);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["completepackage"] && !Shopify.designMode) return;
  try {
    
(() => {
  class LuxuryTabs {
    constructor(container) {
      this.container = container;
      this.tabs = Array.from(this.container.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.container.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;
      this.init();
    }

    init() {
      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
      this.container.addEventListener('keydown', this.onKeyDown.bind(this));
    }

    onTabClick(e) {
      const clickedTab = e.currentTarget;
      if (clickedTab.classList.contains('is-active')) return;

      this.tabs.forEach((tab) => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
        tab.setAttribute('tabindex', '-1');
      });

      this.panels.forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove('is-active');
      });

      clickedTab.classList.add('is-active');
      clickedTab.setAttribute('aria-selected', 'true');
      clickedTab.setAttribute('tabindex', '0');

      const targetPanelId = clickedTab.getAttribute('aria-controls');
      const targetPanel = this.container.querySelector(`#${targetPanelId}`);
      if (targetPanel) {
        targetPanel.hidden = false;
        setTimeout(() => targetPanel.classList.add('is-active'), 10);
      }
    }

    onKeyDown(e) {
      const currentTab = document.activeElement;
      if (currentTab.getAttribute('role') !== 'tab') return;

      let index = this.tabs.indexOf(currentTab);
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        index = (index + 1) % this.tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        index = (index - 1 + this.tabs.length) % this.tabs.length;
      } else {
        return;
      }

      this.tabs[index].click();
      this.tabs[index].focus(); // Ensure keyboard focus moves with selection
    }
  }

  const initLuxuryTabs = () => {
    document.querySelectorAll('.luxury-tabs-section').forEach((section) => {
      if (!section.classList.contains('luxury-tabs-initialized')) {
        new LuxuryTabs(section);
        section.classList.add('luxury-tabs-initialized');
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initLuxuryTabs);
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.luxury-tabs-section')) {
        initLuxuryTabs();
      }
    });
  }

  // Scroll Animation for elements with luxury-scroll-animate class
  document.addEventListener('DOMContentLoaded', () => {
    const scrollAnimatedElements = document.querySelectorAll('.luxury-scroll-animate');
    if (!scrollAnimatedElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('in-view', entry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    scrollAnimatedElements.forEach((el) => observer.observe(el));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experts-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.carousel-item');
    const modal = document.getElementById('videoModal');
    const modalContent = document.getElementById('modalContent');
    const closeModalBtn = document.getElementById('closeModalBtn');

    closeModalBtn.addEventListener('click', () => {
      modal.classList.add('fade-out');
      setTimeout(() => {
        modal.classList.add('hidden');
        modal.classList.remove('fade-out');
        modalContent.innerHTML = '';
      }, 300);
    });

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const videoEl = item.querySelector('video');
        const clone = videoEl.cloneNode(true);
        clone.controls = true;
        clone.muted = false;
        modalContent.innerHTML = '';
        modalContent.appendChild(clone);
        modal.classList.remove('hidden');
      });
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.add('fade-out');
        setTimeout(() => {
          modal.classList.add('hidden');
          modal.classList.remove('fade-out');
          modalContent.innerHTML = '';
        }, 300);
      }
    });

    modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    document.querySelectorAll('.carousel-item video').forEach((video) => {
      observer.observe(video);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["foundation-testkit"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
    const sectionId = ".foundation-full-header";
    const animatedElements = document.querySelectorAll(sectionId + ' .animate-on-scroll');
    if (!animatedElements) { return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, {
      threshold: 0.1
    });
    animatedElements.forEach(el => { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-person-therapy"] && !Shopify.designMode) return;
  try {
    
  const mqDesktop = window.matchMedia('(min-width: 768px)');

  const rafThrottle = (fn) => {
    let pending = false;
    return (...args) => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        fn(...args);
      });
    };
  };

  const inViewObserver = (el, cb, options = { threshold: 0.1 }) => {
    if (!('IntersectionObserver' in window)) {
      cb(true);
      return { disconnect() {} };
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => cb(e.isIntersecting));
    }, options);
    io.observe(el);
    return io;
  };

  const loadScriptOnce = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const s = document.createElement('script');
      s.src = src;
      s.onload = () => resolve();
      s.onerror = reject;
      document.head.appendChild(s);
    });

  const OrbitDots = (() => {
    let root, wrap;

    const build = () => {
      if (!wrap) return;
      wrap.textContent = '';
      const count = parseInt(wrap.dataset.count || wrap.getAttribute('data-count') || '24', 10);
      wrap.style.setProperty('--count', count);
      const frag = document.createDocumentFragment();
      for (let i = 0; i < count; i++) {
        const d = document.createElement('span');
        d.className = 'orbit-dot';
        d.style.setProperty('--i', i);
        frag.appendChild(d);
      }
      wrap.appendChild(frag);
    };

    const onResize = rafThrottle(build);

    return {
      mount() {
        root = document.getElementById('inperson-1');
        wrap = root && root.querySelector('.orbit');
        if (!wrap) return;
        build();
        window.addEventListener('resize', onResize, { passive: true });
      },
      unmount() {
        window.removeEventListener('resize', onResize);
        if (wrap) wrap.textContent = '';
        root = wrap = null;
      },
    };
  })();


  const WipeOverlay = (() => {
    let btn;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const getGeometry = (el) => {
      const r = el.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      const w = window.innerWidth;
      const h = window.innerHeight;
      const maxR = Math.max(
        Math.hypot(cx, cy),
        Math.hypot(w - cx, cy),
        Math.hypot(cx, h - cy),
        Math.hypot(w - cx, h - cy)
      );
      return { cx, cy, maxR };
    };

    const createOverlay = ({ cx, cy }) => {
      const o = document.createElement('div');
      o.className = 'wipe-overlay';
      o.style.setProperty('--cx', `${cx}px`);
      o.style.setProperty('--cy', `${cy}px`);
      o.style.setProperty('--r', '0px');
      document.body.appendChild(o);
      return o;
    };

    const dockOverlay = (overlay, host) => {
      if (!host) return;
      host.classList.add('wipe-host');
      overlay.classList.add('persistent');
      overlay.style.removeProperty('--cx');
      overlay.style.removeProperty('--cy');
      overlay.style.removeProperty('--r');
      overlay.style.removeProperty('clip-path');
      host.prepend(overlay);
    };

    const onClick = async (ev) => {
      const href = btn.getAttribute('href');
      const hostSel = btn.getAttribute('data-scroll-target') || '#online-therapy';
      const host = document.querySelector(hostSel);

      ev.preventDefault();

      if (reduced) {
        if (host) {
          const bg = document.createElement('div');
          bg.className = 'wipe-overlay persistent';
          host.classList.add('wipe-host');
          host.prepend(bg);
          host.scrollIntoView({ behavior: 'instant', block: 'start' });
        } else if (href) {
          window.location.href = href;
        }
        return;
      }

      const geom = getGeometry(btn);
      const overlay = createOverlay(geom);

      await loadScriptOnce('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js');
      const { gsap } = window;

      gsap.to(overlay, {
        duration: 0.9,
        ease: 'power3.inOut',
        '--r': `${geom.maxR}px`,
        onComplete() {
          if (host) {
            dockOverlay(overlay, host);
            host.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else if (href) {
            window.location.href = href;
          }
        },
      });
    };

    return {
      mount() {
        const root = document.getElementById('inperson-1');
        btn = root && root.querySelector('.what-wrapper__btn');
        if (!btn) return;
        btn.addEventListener('click', onClick, { passive: false });
      },
      unmount() {
        if (btn) btn.removeEventListener('click', onClick);
        btn = null;
      },
    };
  })();

  const App = (() => {
    let mountedDesktop = false;

    const mountDesktop = () => {
      if (mountedDesktop) return;
      OrbitDots.mount();
      mountedDesktop = true;
    };

    const unmountDesktop = () => {
      if (!mountedDesktop) return;
      OrbitDots.unmount();
      mountedDesktop = false;
    };

    const onChange = (e) => {
      if (e.matches) mountDesktop();
      else unmountDesktop();
    };

    return {
      init() {
        // always mount overlay (works on all sizes)
        WipeOverlay.mount();

        // desktop-only modules
        onChange(mqDesktop);
        mqDesktop.addEventListener ? mqDesktop.addEventListener('change', onChange) : mqDesktop.addListener(onChange); // Safari ≤14 fallback
      },
    };
  })();

  App.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
class ProductSlider {
  constructor(container, sectionId) {
    this.container = container;
    this.sectionId = sectionId;
    this.slider = this.container.querySelector('.product-image-slider-final');
    // Redefine slides to only include rendered HTML slides
    this.slides = Array.from(this.slider.querySelectorAll('.product-slide'));
    this.controls = this.container.querySelector('.slider-controls-final');
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.autoplayTime = window[`autoplaySpeed_${this.sectionId}`] || 4000;

    // Set the first slide as active immediately
    if (this.slides.length > 0) {
      this.slides[0].classList.add('active');
    }
    
    // Only initialize if there's more than one slide
    if (this.slides.length <= 1) {
       this.controls.style.display = 'none'; // Hide controls if only one slide
       return;
    }

    this.init();
  }

  init() {
    this.createControls();
    this.startAutoplay();
    
    // Stop autoplay on hover
    this.slider.addEventListener('mouseenter', () => clearInterval(this.autoplayInterval));
    this.slider.addEventListener('mouseleave', () => this.startAutoplay());
  }

  createControls() {
    // Iterate over the actual rendered slides to create dots
    this.slides.forEach((_, index) => {
      const dot = document.createElement('div');
      dot.classList.add('dot');
      if (index === this.currentIndex) dot.classList.add('active');
      dot.dataset.index = index;
      dot.addEventListener('click', () => this.goToSlide(index));
      this.controls.appendChild(dot);
    });
    this.dots = Array.from(this.controls.querySelectorAll('.dot'));
  }

  goToSlide(index) {
    if (index >= this.slides.length || index < 0 || index === this.currentIndex) return;
    
    this.slides[this.currentIndex].classList.remove('active');
    if (this.dots.length > 0) this.dots[this.currentIndex].classList.remove('active');
    
    this.currentIndex = index;
    this.slides[this.currentIndex].classList.add('active');
    if (this.dots.length > 0) this.dots[this.currentIndex].classList.add('active');
    
    this.restartAutoplay();
  }

  nextSlide() {
    const newIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(newIndex);
  }

  startAutoplay() {
    if (this.slides.length > 1) {
      this.autoplayInterval = setInterval(() => this.nextSlide(), this.autoplayTime);
    }
  }

  restartAutoplay() {
    clearInterval(this.autoplayInterval);
    this.startAutoplay();
  }

  updateVariantImage(variant) {
    // Find the slide container that holds the variant-specific image (has data-slide-variant-id)
    const variantSlide = this.slides.find(slide => slide.dataset.slideVariantId);
    if (!variantSlide) return;

    const mainImage = variantSlide.querySelector('.main-product-image-final');
    if (!variant.featured_image || !mainImage) return;
    
    // Smooth image update with fade effect
    mainImage.style.opacity = '0.5';
    mainImage.src = `${variant.featured_image.src}&width=600`;
    mainImage.srcset = `${variant.featured_image.src}&width=600`;
    mainImage.alt = variant.featured_image.alt;
    
    // Switch to the main product image slide
    const variantSlideIndex = this.slides.indexOf(variantSlide);
    this.goToSlide(variantSlideIndex);

    setTimeout(() => { mainImage.style.opacity = '1'; }, 150);
    
  }
}

class DynamicProductSection {
  constructor(container) {
    this.container = container;
    this.sectionId = this.container.dataset.sectionId;
    this.variants = window[`productVariants_${this.sectionId}`];
    this.form = this.container.querySelector(`#product-form-${this.sectionId}`);
    if (!this.form) return;

    this.variantIdInput = this.form.querySelector('input[name="id"]');
    this.qtyInput = this.form.querySelector('input[name="quantity"]');
    this.addToCartBtn = this.form.querySelector('.add-to-cart-btn');
    this.buyNowBtn = this.form.querySelector('.buy-now-btn');
    this.soldOutMessage = this.form.querySelector(`#sold-out-message-${this.sectionId}`);
    
    const imageWrapper = this.container.querySelector('.custom-product-image-wrapper');
    this.slider = new ProductSlider(imageWrapper, this.sectionId);
    this.mainImage = imageWrapper.querySelector('.main-product-image-final');

    this.init();
  }

  init() {
    this.form.addEventListener('change', this.onVariantChange.bind(this));
    this.container.addEventListener('click', this.handleClicks.bind(this));
  }

  onVariantChange() {
    const selectedOptions = Array.from(this.form.querySelectorAll('select'), (s) => s.value);
    const selectedVariant = this.variants.find(variant => {
      // Logic to find the matching variant based on all selected options
      return !variant.options.map((option, index) => {
        return selectedOptions[index] === option;
      }).includes(false);
    });

    if (selectedVariant) {
      this.updateAvailability(selectedVariant);
      this.updatePrice(selectedVariant);
      this.updateImage(selectedVariant);
      this.updateUrl(selectedVariant);
    }
  }

  updateAvailability(variant) {
    this.variantIdInput.value = variant.id;
    const isAvailable = variant.available;

    if (this.addToCartBtn) this.addToCartBtn.disabled = !isAvailable;
    if (this.buyNowBtn) this.buyNowBtn.disabled = !isAvailable;

    if (this.soldOutMessage) {
      this.soldOutMessage.style.display = isAvailable ? 'none' : 'block';
    }
  }

  updatePrice(variant) {
    if (!this.addToCartBtn) return;
    const priceWrapper = this.addToCartBtn.querySelector('.price-wrapper');
    if (!priceWrapper) return;
    
    let priceHTML = '';
    if (variant.price > 0) {
      priceHTML += `- ${this.formatMoney(variant.price)}`; 
    }
    if (variant.compare_at_price > variant.price) {
      priceHTML += `<s style="opacity: 0.7; margin-inline-start: 5px;">${this.formatMoney(variant.compare_at_price)}</s>`;
    }
    priceWrapper.innerHTML = priceHTML;
  }

  updateImage(variant) {
    if (this.slider && this.slider.updateVariantImage) {
      this.slider.updateVariantImage(variant);
    } 
    // Fallback if slider wasn't initialized (e.g., if there's only one product image)
    else if (this.mainImage && variant.featured_image) {
      this.mainImage.style.opacity = '0.5';
      this.mainImage.src = `${variant.featured_image.src}&width=600`;
      this.mainImage.srcset = `${variant.featured_image.src}&width=600`;
      this.mainImage.alt = variant.featured_image.alt;
      setTimeout(() => { this.mainImage.style.opacity = '1'; }, 150);
    }
  }

  updateUrl(variant) {
    window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
  }

  handleClicks(e) {
    const down = e.target.closest('.quantity-down');
    if (down) {
      e.preventDefault();
      const currentVal = parseInt(this.qtyInput.value, 10);
      if (currentVal > 1) this.qtyInput.value = currentVal - 1;
      return;
    }
    const up = e.target.closest('.quantity-up');
    if (up) {
      e.preventDefault();
      this.qtyInput.value = parseInt(this.qtyInput.value, 10) + 1;
      return;
    }

    const btn = e.target.closest('.add-to-cart-btn, .buy-now-btn');
    if (!btn) return;
    if (btn.disabled || btn.dataset.loading === 'true') return;
    
    e.preventDefault();
    const isBuyNow = btn.classList.contains('buy-now-btn');
    this.handleFormSubmit(btn, isBuyNow);
  }

  async handleFormSubmit(btn, isBuyNow) {
    this.setBusy(btn, isBuyNow ? 'Verwerken…' : 'Toevoegen…');

    const formData = new FormData(this.form);
    if (isBuyNow) {
       formData.append('quantity', this.qtyInput.value);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(Object.fromEntries(formData.entries())),
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      });
      if (!res.ok) throw new Error(`Add to cart failed (${res.status})`);
      
      const cartData = await res.json();

      if (isBuyNow) {
        window.location.href = '/checkout';
        return;
      }
      
      const textNode = btn.querySelector('.btn-text');
      if (textNode) textNode.innerHTML = 'Toegevoegd!';
      else btn.textContent = 'Toegevoegd!';

      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cartData }));

      setTimeout(() => this.clearBusy(btn), 1200);

    } catch (err) {
      console.error('Error adding to cart:', err);
      const textNode = btn.querySelector('.btn-text');
      if (textNode) textNode.textContent = 'Fout!';
      else btn.textContent = 'Fout!';
      setTimeout(() => this.clearBusy(btn), 1400);
    }
  }
  
  setBusy(btn, label) {
    if (!btn.dataset.originalHtml) {
      btn.dataset.originalHtml = btn.querySelector('.btn-text').innerHTML;
    }
    btn.querySelector('.btn-text').textContent = label;
    btn.disabled = true;
    btn.dataset.loading = 'true';
  }

  clearBusy(btn) {
    if (btn.dataset.originalHtml) {
      btn.querySelector('.btn-text').innerHTML = btn.dataset.originalHtml;
      const currentVariant = this.variants.find(v => v.id == this.variantIdInput.value);
      if (currentVariant) {
         btn.disabled = !currentVariant.available;
      }
    }
    btn.dataset.loading = 'false';
  }

  formatMoney(cents) {
    // Uses Shopify's global money format function if available, or a simple fallback
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        // NOTE: This uses the Liquid 'shop.money_format' passed as a string placeholder
        return Shopify.formatMoney(cents, '{{ shop.money_format | escape }}'); 
    }
    const value = (cents / 100).toFixed(2);
    const currency = window.Shopify?.currency?.active || 'EUR'; 
    const symbol = ({ 'USD': '$', 'EUR': '€' })[currency] || currency + ' ';
    return `${symbol}${value}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-product-page-final').forEach((section) => {
    new DynamicProductSection(section);
  });
});
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.custom-product-page-final');
  if (section) {
    new DynamicProductSection(section);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["online-EMDR-therapy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mqDesktop = window.matchMedia('(min-width: 1024px)');
    const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* ---------- utilities ---------- */
    const rafThrottle = (fn) => {
      let pending = false;
      return (...args) => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          fn(...args);
        });
      };
    };

    let gsapLoadPromise = null;
    const ensureGSAP = () => {
      if (window.gsap && window.ScrollTrigger) {
        try {
          window.gsap.registerPlugin(window.ScrollTrigger);
        } catch (_) {}
        return Promise.resolve({ gsap: window.gsap, ScrollTrigger: window.ScrollTrigger });
      }
      if (!gsapLoadPromise) {
        gsapLoadPromise = new Promise((resolve, reject) => {
          let pending = 0;
          const onDone = () => {
            if (window.gsap && window.ScrollTrigger) {
              try {
                window.gsap.registerPlugin(window.ScrollTrigger);
              } catch (_) {}
              resolve({ gsap: window.gsap, ScrollTrigger: window.ScrollTrigger });
            }
          };
          const load = (src) => {
            pending++;
            const s = document.createElement('script');
            s.src = src;
            s.onload = () => {
              pending--;
              if (pending === 0) onDone();
            };
            s.onerror = reject;
            document.head.appendChild(s);
          };
          if (!window.gsap) load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js');
          if (!window.ScrollTrigger) load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js');
        });
      }
      return gsapLoadPromise;
    };

    /* Keep disposers per section so we can clean up on section unload */
    const sectionDisposers = new WeakMap();

    function mountSection(section) {
      // Allow either #emdr-1.emdr-online-therapy or just .emdr-online-therapy within the root
      const root = section.matches?.('.emdr-online-therapy')
        ? section
        : section.querySelector?.('#emdr-1.emdr-online-therapy, .emdr-online-therapy');

      if (!root) return;
      const disposers = [];
      sectionDisposers.set(section, disposers);

      /* --------- 1) Card reveal (GSAP) --------- */
      const cards = root.querySelectorAll('.emdr__card');
      const hero = root.querySelector('.emdr__hero');

      const runReveal = () => {
        if (mqReduced.matches || !cards.length || !hero) return;
        ensureGSAP()
          .then(({ gsap, ScrollTrigger }) => {
            gsap.set(cards, { opacity: 0, y: 40 });
            const tween = gsap.to(cards, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: 'power2.out',
              stagger: 0.2,
              scrollTrigger: {
                trigger: hero,
                start: 'top 80%',
                once: true,
              },
            });
            // disposer for GSAP/ScrollTrigger
            disposers.push(() => {
              try {
                tween?.kill?.();
              } catch (_) {}
              try {
                ScrollTrigger?.getAll?.().forEach((t) => t.kill());
              } catch (_) {}
            });
          })
          .catch(() => {});
      };
      runReveal();

      /* --------- 2) Wire drawing SVG (desktop only, no/reduced motion guard) --------- */
      const connectWrap = root.querySelector('.emdr__connect');
      const svg = connectWrap?.querySelector('.emdr__wires');
      const pathL = svg?.querySelector('.w-left');
      const pathM = svg?.querySelector('.w-mid');
      const pathR = svg?.querySelector('.w-right');
      const video = connectWrap?.querySelector('.emdr__player-inner');
      const cardEls = connectWrap?.querySelectorAll('.emdr__card') || [];

      const drawPath = (path, sx, sy, ex, ey) => {
        if (!path) return;
        const c1x = sx,
          c1y = sy + (ey - sy) * 0.55;
        const c2x = ex,
          c2y = c1y;
        path.setAttribute('d', `M ${sx},${sy} C ${c1x},${c1y} ${c2x},${c2y} ${ex},${ey}`);
      };

      const updateWires = () => {
        if (mqReduced.matches || !mqDesktop.matches) return;
        if (!connectWrap || !svg || !video || !cardEls.length) return;

        const wrapRect = connectWrap.getBoundingClientRect();
        const videoRect = video.getBoundingClientRect();

        const width = Math.max(1, Math.round(wrapRect.width));
        const height = Math.max(1, Math.round(wrapRect.height));
        svg.setAttribute('viewBox', `0 0 ${width} ${height}`);

        const sy = videoRect.bottom - wrapRect.top + 10;
        const vLeft = videoRect.left - wrapRect.left;
        const vRight = videoRect.right - wrapRect.left;
        const vCenter = (vLeft + vRight) / 2;

        const getCenterX = (rect) => rect.left - wrapRect.left + rect.width / 2;

        const cRects = Array.from(cardEls).map((c) => c.getBoundingClientRect());
        const ey = Math.min(...cRects.map((r) => r.top - wrapRect.top)) - 16;

        const end1x = cRects[0] ? getCenterX(cRects[0]) : vLeft + (vRight - vLeft) * 0.2;
        const end2x = cRects[1] ? getCenterX(cRects[1]) : vCenter;
        const end3x = cRects[2] ? getCenterX(cRects[2]) : vRight - (vRight - vLeft) * 0.2;

        drawPath(pathL, vLeft + (vRight - vLeft) * 0.18, sy, end1x, ey);
        drawPath(pathM, vCenter, sy, end2x, ey);
        drawPath(pathR, vRight - (vRight - vLeft) * 0.18, sy, end3x, ey);
      };
      const updateWiresThrottled = rafThrottle(updateWires);

      // Only enable wire logic on desktop & when not reduced-motion
      const reevaluateWires = () => {
        if (!connectWrap || !svg) return;
        if (mqReduced.matches || !mqDesktop.matches) return;
        updateWiresThrottled();
        // flag for CSS once geometry is ready
        requestAnimationFrame(() => svg.classList.add('is-ready'));
      };

      reevaluateWires();

      // Observe size changes precisely
      let ro = null;
      if ('ResizeObserver' in window && connectWrap) {
        ro = new ResizeObserver(updateWiresThrottled);
        ro.observe(connectWrap);
        if (video) ro.observe(video);
        cardEls.forEach((c) => ro.observe(c));
        disposers.push(() => ro.disconnect());
      }

      // Window resize fallback (and to catch viewport changes)
      const onResize = () => updateWiresThrottled();
      window.addEventListener('resize', onResize, { passive: true });
      disposers.push(() => window.removeEventListener('resize', onResize));

      // react to media query changes
      const onMQChange = () => reevaluateWires();
      if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', onMQChange);
      else mqDesktop.addListener(onMQChange);
      if (mqReduced.addEventListener) mqReduced.addEventListener('change', onMQChange);
      else mqReduced.addListener(onMQChange);

      disposers.push(() => {
        if (mqDesktop.removeEventListener) mqDesktop.removeEventListener('change', onMQChange);
        else mqDesktop.removeListener(onMQChange);
        if (mqReduced.removeEventListener) mqReduced.removeEventListener('change', onMQChange);
        else mqReduced.removeListener(onMQChange);
      });
    }

    function unmountSection(section) {
      const disposers = sectionDisposers.get(section);
      if (!disposers) return;
      disposers.reverse().forEach((d) => {
        try {
          d();
        } catch (_) {}
      });
      sectionDisposers.delete(section);
    }

    /* ---------- bootstrap for DOM + Theme Editor ---------- */
    const boot = (root) => {
      const scope = root && root.querySelector ? root : document;
      // handle one or many instances
      scope.querySelectorAll('#emdr-1.emdr-online-therapy, .emdr-online-therapy').forEach((section) => {
        // if this element is a child of a larger root, pass the container the Theme Editor gives us
        mountSection(section);
      });
    };

    document.addEventListener('DOMContentLoaded', () => boot(document));
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    document.addEventListener('shopify:section:unload', (e) => unmountSection(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["online-therapy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('online-therapy');
    if (!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Pause spotlight video when off-screen + gentle speed
    (function () {
      var vid = root.querySelector('.spotlight__video');
      if (!vid) return;
      function setRate() {
        try {
          vid.playbackRate = 0.85;
        } catch (e) {}
      }
      vid.addEventListener('loadedmetadata', setRate, { once: true });

      if (reduce) {
        vid.pause();
        vid.removeAttribute('autoplay');
        return;
      }
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                vid.play().catch(function () {});
              } else {
                vid.pause();
              }
            });
          },
          { threshold: 0.2 }
        );
        vio.observe(vid);
      }
    })();

    if (reduce) return;

    function ensureGSAP(cb) {
      if (window.gsap && window.ScrollTrigger) {
        cb();
        return;
      }
      var s1 = document.createElement('script');
      s1.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
      var s2 = document.createElement('script');
      s2.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
      s1.onload = function () {
        document.head.appendChild(s2);
        s2.onload = function () {
          gsap.registerPlugin(ScrollTrigger);
          cb();
        };
      };
      document.head.appendChild(s1);
    }

    ensureGSAP(function () {
      var section = root;
      var spot = root.querySelector('.spotlight__video, .spotlight__img');
      var sheet = root.querySelector('.ot-sheet');

      // Parallax on spotlight media
      if (spot) {
        gsap.fromTo(
          spot,
          { y: 0, scale: 1 },
          {
            y: -40,
            scale: 1.04,
            ease: 'none',
            scrollTrigger: { trigger: section, start: 'top bottom', end: 'bottom top', scrub: 0.4 },
          }
        );
      }

      // Header reveal
      gsap.from(root.querySelector('.ot-eyebrow'), {
        y: 12,
        autoAlpha: 0,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: { trigger: section, start: 'top 75%' },
      });
      gsap.from(root.querySelector('.ot-title'), {
        y: 14,
        autoAlpha: 0,
        duration: 0.7,
        ease: 'power2.out',
        delay: 0.05,
        scrollTrigger: { trigger: section, start: 'top 75%' },
      });

      // Sheet pop + staggered columns
      if (sheet) {
        gsap.from(sheet, {
          opacity: 0,
          y: 18,
          scale: 0.98,
          duration: 0.9,
          ease: 'power3.out',
          scrollTrigger: { trigger: sheet, start: 'top 80%' },
        });
        gsap.from(sheet.querySelectorAll('.ot-sheet__col'), {
          y: 10,
          autoAlpha: 0,
          duration: 0.65,
          ease: 'power2.out',
          stagger: 0.12,
          scrollTrigger: { trigger: sheet, start: 'top 78%' },
        });
      }

      // Subtle 3D tilt on desktop pointers
      if (window.matchMedia('(pointer:fine)').matches && sheet) {
        var leave = function () {
          gsap.to(sheet, { rotateX: 0, rotateY: 0, duration: 0.4, ease: 'power2.out' });
        };
        sheet.addEventListener('pointermove', function (e) {
          var r = sheet.getBoundingClientRect();
          var dx = (e.clientX - r.left) / r.width - 0.5;
          var dy = (e.clientY - r.top) / r.height - 0.5;
          gsap.to(sheet, { rotateY: dx * -4, rotateX: dy * 4, duration: 0.3, ease: 'sine.out' });
        });
        sheet.addEventListener('pointerleave', leave);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["probtestkit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.editorial-symptoms-section');
    if (!section) {
      return;
    }
    const animatedElements = section.querySelectorAll('.animate-on-scroll');
    if (animatedElements.length === 0) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: 0.1,
      }
    );
    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-application"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const mqReduced = matchMedia('(prefers-reduced-motion: reduce)');

    const rafThrottle = (fn) => {
      let pending = false;
      return (...args) => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          fn(...args);
        });
      };
    };

    const debounce = (fn, delay = 180) => {
      let t;
      return (...a) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...a), delay);
      };
    };

    // Random helper (deterministic-ish per element for less layout flicker)
    const seeded = (seed) => {
      let s = seed >>> 0;
      return () => (s = (s * 1664525 + 1013904223) >>> 0) / 0xffffffff;
    };

    function mountCloud(root) {
      const cloud = root.querySelector('.apps-cloud-inner');
      if (!cloud) return;

      const bubbles = Array.from(cloud.querySelectorAll('.app-bubble'));
      if (!bubbles.length) return;

      // Shuffle stacking order for variety (stable-ish using element index as seed)
      (function shuffle() {
        const rnd = seeded(bubbles.length);
        for (let i = bubbles.length - 1; i > 0; i--) {
          const j = Math.floor(rnd() * (i + 1));
          if (j !== i) cloud.appendChild(bubbles[j]);
          [bubbles[i], bubbles[j]] = [bubbles[j], bubbles[i]];
        }
      })();

      // Place bubbles using best-candidate sampling (non-overlapping & well spread)
      const placeBubbles = () => {
        const rect = cloud.getBoundingClientRect();
        const vw = Math.max(320, innerWidth || 0);
        const pad = vw < 600 ? 10 : 18; // inner padding
        const triesPerBubble = 14; // higher => better spread
        const placed = [];

        bubbles.forEach((b, idx) => {
          // Random-but-stable per bubble
          const rnd = seeded(idx + 1);

          // Size (allow override via data-size)
          const base = vw < 500 ? 44 : 56;
          const jitter = vw < 500 ? 20 : 28;
          const dataSize = parseInt(b.dataset.size || '', 10);
          const size = isNaN(dataSize) ? Math.round(base + rnd() * jitter) : dataSize;

          b.style.setProperty('--size', size + 'px');
          b.style.setProperty('--z', String(1 + Math.floor(rnd() * 3)));

          // Motion vars (CSS uses them; reduced motion keeps values but you can dampen in CSS)
          const pick = (min, max) => Math.round(rnd() * (max - min) + min);
          const sign = () => (rnd() < 0.5 ? -1 : 1);

          b.style.setProperty('--dx1', sign() * pick(6, 16) + 'px');
          b.style.setProperty('--dy1', sign() * pick(6, 16) + 'px');
          b.style.setProperty('--dx2', sign() * pick(6, 16) + 'px');
          b.style.setProperty('--dy2', sign() * pick(6, 16) + 'px');
          b.style.setProperty('--dx3', sign() * pick(4, 14) + 'px');
          b.style.setProperty('--dy3', sign() * pick(4, 14) + 'px');
          b.style.setProperty('--dur', (5.5 + rnd() * 3.5).toFixed(2) + 's');
          b.style.setProperty('--delay', (-rnd() * 3).toFixed(2) + 's');
          b.style.setProperty('--rockDur', (4.5 + rnd() * 2.5).toFixed(2) + 's');
          b.style.setProperty('--rockDelay', (-rnd() * 2).toFixed(2) + 's');
          b.style.setProperty('--r0', Math.round(-(1 + rnd() * 2)) + 'deg');
          b.style.setProperty('--r1', Math.round(1 + rnd() * 2) + 'deg');

          if (b.dataset.lock === 'true') return; // keep manual positions if set

          // Best candidate sampling inside the cloud rect
          let best = null,
            bestScore = -1;
          const bw = size,
            bh = size;

          for (let t = 0; t < triesPerBubble; t++) {
            const x = pad + Math.random() * Math.max(1, rect.width - pad * 2 - bw);
            const y = pad + Math.random() * Math.max(1, rect.height - pad * 2 - bh);
            const cx = x + bw / 2,
              cy = y + bh / 2;

            // Distance to nearest placed bubble (treat as soft circles)
            let minD = Infinity;
            for (const p of placed) {
              const d = Math.hypot(p.cx - cx, p.cy - cy) - (p.r + bw / 2);
              if (d < minD) minD = d;
            }

            // Slight preference toward center
            const centerBiasX = rect.width / 2 - Math.abs(cx - rect.width / 2);
            const centerBiasY = rect.height / 2 - Math.abs(cy - rect.height / 2);
            const score = (isFinite(minD) ? minD : 9999) + (centerBiasX + centerBiasY) * 0.035;

            if (score > bestScore) {
              bestScore = score;
              best = { x, y, cx, cy, r: bw / 2 + 8 };
            }
          }

          if (best) {
            b.style.left = best.x + 'px';
            b.style.top = best.y + 'px';
            placed.push(best);
          }
        });
      };

      let parallaxBound = null;
      const onParallaxMove = rafThrottle((e) => {
        const r = cloud.getBoundingClientRect();
        const mx = (e.clientX - r.left) / r.width - 0.5;
        const my = (e.clientY - r.top) / r.height - 0.5;
        const damp = mqReduced.matches ? 0.4 : 1;

        bubbles.forEach((b) => {
          const depth = parseInt(getComputedStyle(b).getPropertyValue('--z')) || 1;
          const nudge = (2 / depth) * damp; // closer items move more
          b.style.transform = `translate(${(mx * nudge).toFixed(2)}px, ${(my * nudge).toFixed(2)}px)`;
        });
      });
      const onParallaxLeave = () => {
        bubbles.forEach((b) => {
          b.style.transform = 'translate(0, 0)';
        });
      };

      const enableParallax = () => {
        if (!matchMedia('(pointer: fine)').matches) return;
        cloud.classList.add('parallax');
        parallaxBound = (e) => onParallaxMove(e);
        cloud.addEventListener('mousemove', parallaxBound);
        cloud.addEventListener('mouseleave', onParallaxLeave);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) onParallaxLeave();
        });
      };

      const layout = rafThrottle(placeBubbles);
      const reset = debounce(() => layout(), 120);

      const ro = new ResizeObserver(reset);
      ro.observe(cloud);

      layout();
      addEventListener('resize', reset, { passive: true });
      enableParallax();

      return () => {
        ro.disconnect();
        removeEventListener('resize', reset);
        if (parallaxBound) {
          cloud.removeEventListener('mousemove', parallaxBound);
          cloud.removeEventListener('mouseleave', onParallaxLeave);
        }
      };
    }

    // NEW: No-hash open/close for app detail cards (works with <button class="app-bubble">)
    function bindCardClicks(section) {
      if (!section) return () => {};

      const onClick = (e) => {
        // Open from bubble button
        const bubble = e.target.closest('.app-bubble');
        if (bubble && section.contains(bubble)) {
          const targetSel = bubble.dataset.target; // e.g. "#app-card-1"
          // close all currently open cards
          section.querySelectorAll('.app-detail.is-open').forEach((el) => el.classList.remove('is-open'));
          // reset aria-expanded on all bubbles
          section
            .querySelectorAll('.app-bubble[aria-expanded]')
            .forEach((b) => b.setAttribute('aria-expanded', 'false'));
          // open the requested card
          if (targetSel) {
            const card = section.querySelector(targetSel);
            if (card) {
              card.classList.add('is-open');
              bubble.setAttribute('aria-expanded', 'true');
            }
          }
          return;
        }

        // Close via × button
        const closeBtn = e.target.closest('.app-detail-close');
        if (closeBtn && section.contains(closeBtn)) {
          const card = closeBtn.closest('.app-detail');
          if (card) {
            card.classList.remove('is-open');
            const id = card.id;
            if (id) {
              const opener = section.querySelector(`.app-bubble[aria-controls="${id}"]`);
              opener?.setAttribute('aria-expanded', 'false');
            }
          }
        }
      };

      section.addEventListener('click', onClick);
      return () => section.removeEventListener('click', onClick);
    }

    // Mount both cloud + card handlers per section and provide a disposer
    const mountAll = (scope) => {
      (scope.querySelectorAll?.('#apps-showcase') || []).forEach((section) => {
        // dispose previous
        section.__appsDispose?.();

        const disposeCloud = mountCloud(section);
        const disposeCards = bindCardClicks(section);

        section.__appsDispose = () => {
          disposeCloud && disposeCloud();
          disposeCards && disposeCards();
        };
      });
    };

    document.addEventListener('DOMContentLoaded', () => mountAll(document));
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target?.matches('#apps-showcase') || e.target?.querySelector('#apps-showcase')) {
        mountAll(e.target);
      }
    });
    document.addEventListener('shopify:section:unload', (e) => {
      e.target?.__appsDispose?.();
      e.target.__appsDispose = null;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-evidence-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initCarousel(root) {
      if (!root || root.dataset.evbInited === '1') return;
      root.dataset.evbInited = '1';

      const viewport = root.querySelector('.evb-viewport');
      const track    = root.querySelector('.evb-track');
      const prevBtn  = root.querySelector('.evb-prev');
      const nextBtn  = root.querySelector('.evb-next');
      const catBtns  = Array.from(root.querySelectorAll('.evb-cat'));
      const allSlides = Array.from(root.querySelectorAll('.evb-slide'));
      if (!viewport || !track || !prevBtn || !nextBtn) return;

      let pageOffsets = [];
      let pageIndex = 0;
      let pagesCount = 0;

      const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
      const visibleSlides = () => allSlides.filter(el => !el.hasAttribute('hidden'));

      // How many slides currently fit without scrolling
      function slidesPerView() {
        const slides = visibleSlides();
        if (slides.length <= 1) return slides.length;
        const vpRect = viewport.getBoundingClientRect();
        const firstLeft = slides[0].getBoundingClientRect().left;
        let count = 0;
        for (let i = 0; i < slides.length; i++) {
          const r = slides[i].getBoundingClientRect();
          if (r.right - firstLeft <= vpRect.width + 1) count++;
          else break;
        }
        return Math.max(1, count);
      }

      // Cleanly hide/show nav buttons
      function setNavHidden(hidden) {
        [prevBtn, nextBtn].forEach(btn => {
          btn.style.display = hidden ? 'none' : '';
          btn.setAttribute('aria-hidden', String(hidden));
          btn.tabIndex = hidden ? -1 : 0;
        });
      }

      function refreshNavVisibility() {
        const count = visibleSlides().length;

        // Requirement: if there are exactly two articles -> remove (hide) prev/next
        if (count === 2) {
          setNavHidden(true);
          return;
        }

        // Also hide nav if navigation isn't needed (everything fits in view)
        const spv = Math.max(1, slidesPerView());
        const needsNav = count > spv;
        setNavHidden(!needsNav);
      }

      function updateNavState() {
        // Called after pageIndex changes; also ensure visibility reflects current layout
        const atStart = pageIndex <= 0 || pagesCount === 0;
        const atEnd   = pagesCount === 0 || pageIndex >= pagesCount - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
        prevBtn.setAttribute('aria-disabled', String(atStart));
        nextBtn.setAttribute('aria-disabled', String(atEnd));
        refreshNavVisibility();
      }

      function computePages(targetFirstIndex = 0) {
        const slides = visibleSlides();
        const spv = Math.max(1, slidesPerView());

        if (slides.length === 0) {
          pagesCount = 0;
          pageOffsets = [0];
          pageIndex = 0;
          viewport.scrollLeft = 0;
          updateNavState();
          return;
        }

        pagesCount = Math.ceil(slides.length / spv);

        // IMPORTANT: use offsetLeft (relative to the scrollable content),
        // not getBoundingClientRect(), so values are stable during scroll/filter.
        pageOffsets = [];
        for (let p = 0; p < pagesCount; p++) {
          const firstIdx = p * spv;
          const slide = slides[firstIdx];
          pageOffsets.push(slide.offsetLeft);
        }

        pageIndex = clamp(targetFirstIndex, 0, Math.max(0, pagesCount - 1));
        scrollToPage(pageIndex, false);
        updateNavState();
      }

      function scrollToPage(i, smooth = true) {
        if (!pageOffsets.length || pagesCount === 0) {
          viewport.scrollLeft = 0;
          updateNavState();
          return;
        }
        const left = pageOffsets[clamp(i, 0, pagesCount - 1)];
        if (typeof viewport.scrollTo === 'function' && smooth) {
          viewport.scrollTo({ left, behavior: 'smooth' });
        } else {
          viewport.scrollLeft = left;
        }
        pageIndex = clamp(i, 0, pagesCount - 1);
        updateNavState();
      }

      // Prev / Next handlers
      prevBtn.addEventListener('click', () => {
        if (!prevBtn.disabled) scrollToPage(pageIndex - 1, true);
      });
      nextBtn.addEventListener('click', () => {
        if (!nextBtn.disabled) scrollToPage(pageIndex + 1, true);
      });

      // Category filtering with stable scroll + reflow-safe recompute
      catBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const pageY = window.scrollY || window.pageYOffset;

          catBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          viewport.style.setProperty('overflow-anchor', 'none');

          const cat = btn.dataset.cat;
          if (cat && cat !== '*') {
            allSlides.forEach((slide) => {
              slide.toggleAttribute('hidden', slide.dataset.cat !== cat);
            });
          } else {
            allSlides.forEach((slide) => slide.removeAttribute('hidden'));
          }

          // Reset scroll and recompute pages based on new visible set
          pageIndex = 0;
          viewport.scrollLeft = 0;

          // Wait a frame for layout to settle before measuring
          requestAnimationFrame(() => {
            computePages(0);
            window.scrollTo({ top: pageY });
            viewport.style.removeProperty('overflow-anchor');
          });
        });
      });

      // Keep page index roughly synced on manual scroll
      let rafId = null;
      viewport.addEventListener('scroll', () => {
        if (!pageOffsets.length) return;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const left = viewport.scrollLeft;
          let nearest = 0, minDist = Infinity;
          for (let i = 0; i < pageOffsets.length; i++) {
            const d = Math.abs(left - pageOffsets[i]);
            if (d < minDist) { minDist = d; nearest = i; }
          }
          if (nearest !== pageIndex) {
            pageIndex = nearest;
            updateNavState();
          }
        });
      }, { passive: true });

      // Resize observer: recompute on viewport size changes
      const ro = window.ResizeObserver ? new ResizeObserver(() => {
        // Keep the same first slide in view when resizing
        computePages(pageIndex);
      }) : null;
      ro && ro.observe(viewport);

      // Initial layout
      viewport.scrollLeft = 0;
      computePages(0);
    }

    // Boot on DOM ready
    const boot = (ctx = document) => {
      ctx.querySelectorAll('#evidence-carousel').forEach(initCarousel);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    // Shopify Theme Editor dynamic loads
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-workbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('workbook'); // <-- updated to match your markup
    if (!root) return;

    const details = root.querySelector('.wb-disclosure');
    if (!details) return;

    const summary = details.querySelector('summary');
    const content = details.querySelector('.wb-disclosure-content');
    if (!summary || !content) return;

    // Respect reduced motion
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const DURATION = 280; // ms
    const EASING = 'ease';

    content.style.overflow = 'hidden';

    const onTransitionEnd = (cb) => {
      function handler(e) {
        if (e.propertyName !== 'height') return;
        content.removeEventListener('transitionend', handler);
        cb && cb();
      }
      content.addEventListener('transitionend', handler);
    };

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (details.dataset.animating === '1') return;
      details.dataset.animating = '1';

      if (!details.open) {
        details.open = true;
        content.style.height = '0px';
        requestAnimationFrame(() => {
          content.style.transition = `height ${DURATION}ms ${EASING}`;
          content.style.height = content.scrollHeight + 'px';
        });
        onTransitionEnd(() => {
          content.style.height = '';
          content.style.transition = '';
          delete details.dataset.animating;
        });
      } else {
        const startHeight = content.scrollHeight;
        content.style.height = startHeight + 'px';
        requestAnimationFrame(() => {
          content.style.transition = `height ${DURATION}ms ${EASING}`;
          content.style.height = '0px';
        });
        onTransitionEnd(() => {
          details.open = false;
          content.style.height = '';
          content.style.transition = '';
          delete details.dataset.animating;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-activities"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth < 1024) return;

    const track = document.querySelector('.spa-activities__grid');
    if (!track) return;

    // duplicate for seamless loop
    track.innerHTML += track.innerHTML;

    // ---- RTL-safe scroll helpers ----
    const isRTL = () =>
      (document.documentElement.dir || getComputedStyle(document.documentElement).direction) === 'rtl';

    const getRtlScrollType = (() => {
      let cached;
      return () => {
        if (cached) return cached;
        const outer = document.createElement('div');
        outer.dir = 'rtl';
        outer.style.cssText = 'width:100px;height:100px;overflow:auto;position:absolute;top:-9999px;';
        const inner = document.createElement('div');
        inner.style.width = '200px';
        inner.style.height = '1px';
        outer.appendChild(inner);
        document.body.appendChild(outer);

        outer.scrollLeft = 0;
        // detect model
        if (outer.scrollLeft === 0) {
          outer.scrollLeft = 1;
          cached = outer.scrollLeft === 0 ? 'negative' : 'default';
        } else {
          cached = 'reverse';
        }
        document.body.removeChild(outer);
        return cached;
      };
    })();

    const getScrollLeftLogical = (el) => {
      if (!isRTL()) return el.scrollLeft;
      const t = getRtlScrollType();
      const { scrollLeft, scrollWidth, clientWidth } = el;
      if (t === 'negative') return -scrollLeft; // Chrome
      if (t === 'reverse') return scrollWidth - clientWidth - scrollLeft; // Safari/old
      return scrollLeft; // Firefox 'default'
    };

    const setScrollLeftLogical = (el, x) => {
      if (!isRTL()) {
        el.scrollLeft = x;
        return;
      }
      const t = getRtlScrollType();
      const { scrollWidth, clientWidth } = el;
      if (t === 'negative') el.scrollLeft = -x;
      else if (t === 'reverse') el.scrollLeft = scrollWidth - clientWidth - x;
      else el.scrollLeft = x;
    };

    let rafId = null;
    const half = track.scrollWidth / 2; 
    const speed = 0.6; 
    const flip = isRTL();

    let x = getScrollLeftLogical(track) || 0;

    const animate = () => {
      // move: LTR -> +, RTL -> -
      x += flip ? -speed : speed;

      // wrap within [0, half)
      if (x >= half) x -= half;
      if (x < 0) x += half;

      setScrollLeftLogical(track, x);
      rafId = requestAnimationFrame(animate);
    };

    // start
    animate();

    // pause on hover; resume on leave
    track.addEventListener('mouseenter', () => cancelAnimationFrame(rafId));
    track.addEventListener('mouseleave', () => (rafId = requestAnimationFrame(animate)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sport-therapy-testimonial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // ---- DOM refs ----
  const section   = document.querySelector('.testimonial-carousel-sport-section');
  if (!section) return;

  const container = section.querySelector('.carousel-container');
  const track     = section.querySelector('.testimonial-carousel-track');
  if (!container || !track) return;

  const items         = section.querySelectorAll('.carousel-item');
  const modal         = document.getElementById('videoModal');
  const modalContent  = document.getElementById('modalContent');
  const closeModalBtn = document.getElementById('closeModalBtn');

  // ---- Feature flags ----
  const isMobile      = window.matchMedia('(max-width: 767px)').matches;
  const reduceMotion  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // =========================================================
  // 1) VERTICAL MARQUEE (negative translateY) — desktop only
  // =========================================================
  if (!isMobile && !reduceMotion) {
    // Duplicate children once for seamless looping
    const originals = Array.from(track.children);
    originals.forEach(node => track.appendChild(node.cloneNode(true)));

    let loopHeight = 1;   // height of a single set of items
    let offset = 0;       // how far we've translated (in px)
    let speed = 60;       // px per second (tweak)
    let playing = false;
    let rafId;
    let last = performance.now();

    const measure = () => {
      // total height is 2x originals after duplication
      loopHeight = Math.max(1, track.scrollHeight / 2);
    };

    // measure on load + resize + content changes
    measure();
    window.addEventListener('load', measure, { once: true });
    const ro = new ResizeObserver(measure);
    ro.observe(track);
    ro.observe(container);
    window.addEventListener('resize', measure, { passive: true });

    const tick = (now) => {
      const dt = (now - last) / 1000;
      last = now;

      offset += speed * dt;           // grow offset
      if (offset >= loopHeight) {
        // wrap cleanly to keep it seamless
        offset = offset % loopHeight;
      }

      // NEGATIVE translation: content moves upward visually
      track.style.transform = `translate3d(0, ${-offset}px, 0)`;
      track.style.willChange = 'transform';

      rafId = requestAnimationFrame(tick);
    };

    const play = () => {
      if (playing) return;
      playing = true;
      last = performance.now();
      rafId = requestAnimationFrame(tick);
    };

    const pause = () => {
      if (!playing) return;
      playing = false;
      cancelAnimationFrame(rafId);
    };

    // Pause/resume based on viewport visibility
    const visIO = new IntersectionObserver((entries) => {
      entries.forEach(entry => entry.isIntersecting ? play() : pause());
    }, { threshold: 0 });

    visIO.observe(container);

    // If already visible, start immediately
    const r = container.getBoundingClientRect();
    if (r.bottom > 0 && r.top < window.innerHeight) play();
  }

  // =========================================================
  // 2) MODAL open/close with video clone
  // =========================================================
  const closeModal = () => {
    if (!modal) return;
    modal.classList.add('fade-out');
    setTimeout(() => {
      modal.classList.add('hidden');
      modal.classList.remove('fade-out');
      if (modalContent) {
        const v = modalContent.querySelector('video');
        if (v) { try { v.pause(); } catch(_){} }
        modalContent.innerHTML = '';
      }
    }, 300);
  };

  closeModalBtn && closeModalBtn.addEventListener('click', closeModal);

  modal && modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  modalContent && modalContent.addEventListener('click', (e) => e.stopPropagation());

  // Open modal when clicking a carousel item that has a <video>
  items.forEach(item => {
    item.addEventListener('click', () => {
      const videoEl = item.querySelector('video');
      if (!videoEl || !modal || !modalContent) return;
      const clone = videoEl.cloneNode(true);
      clone.controls = true;
      clone.muted = false;
      try { clone.currentTime = 0; } catch(_) {}
      modalContent.innerHTML = '';
      modalContent.appendChild(clone);
      modal.classList.remove('hidden');
      requestAnimationFrame(() => { clone.play().catch(()=>{}); });
    });
  });

  // =========================================================
  // 3) Auto play/pause videos as they enter/leave view
  // =========================================================
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (!(video instanceof HTMLVideoElement)) return;
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        try { video.pause(); } catch(_) {}
      }
    });
  }, { threshold: 0.5 });

  section.querySelectorAll('.carousel-item video').forEach(v => io.observe(v));

  // Optional: main hero video auto play/pause
  const mainVideo = section.querySelector('.testimonial-carousel-video-wrapper video');
  if (mainVideo) {
    const mainIO = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) mainVideo.play().catch(()=>{});
        else { try { mainVideo.pause(); } catch(_) {} }
      });
    }, { threshold: 0.5 });
    mainIO.observe(mainVideo);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["start-journey-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const points = document.querySelectorAll('.sj-point');
    if (!('IntersectionObserver' in window)) {
      points.forEach((p) => p.classList.add('in-view'));
    } else {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );
      points.forEach((p) => io.observe(p));
    }

    // Handle every section instance
    document.querySelectorAll('.sport-canvas').forEach((root) => {
      const tiles = Array.from(root.querySelectorAll('.sport-tile'));
      if (!tiles.length) return;

      const maxAttr = Math.min(parseInt(root.dataset.max || '5', 10), tiles.length);

      // Shuffle tiles
      for (let i = tiles.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [tiles[i], tiles[j]] = [tiles[j], tiles[i]];
      }

      // Slot maps per breakpoint
      const slotsMobile = [
        { left: 4, top: 6 },
        { left: 52, top: 2 },
        { left: 20, top: 34 },
        { left: 68, top: 32 },
        { left: 38, top: 62 },
      ];
      const slotsTablet = [
        { left: 0, top: 42 },
        { left: 22, top: 8 },
        { left: 44, top: 38 },
        { left: 66, top: 10 },
        { left: 34, top: 60 },
      ];
      const slotsDesktop = [
        { left: 2, top: 50 },
        { left: 26, top: 12 },
        { left: 50, top: 48 },
        { left: 74, top: 14 },
        { left: 38, top: 66 },
      ];

      const getBP = () =>
        window.matchMedia('(min-width:1024px)').matches
          ? 'd'
          : window.matchMedia('(min-width:640px)').matches
          ? 't'
          : 'm';

      const pickSlots = (bp) => (bp === 'd' ? slotsDesktop : bp === 't' ? slotsTablet : slotsMobile);

      // Desired visible counts per breakpoint
      const bpMax = (bp) => {
        if (bp === 'm') return Math.min(2, tiles.length); // mobile
        if (bp === 't') return Math.min(4, tiles.length); // tablet
        return Math.min(maxAttr, tiles.length); // desktop: from data-max (default 5)
      };

      const accents = [
        '#E9F1FB',
        '#E6F0FF',
        '#DCEBFF',
        '#EDE9FE',
        '#E9D5FF',
        '#FFE4E6',
        '#FFE7D9',
        '#FFEDD5',
        '#FEF3C7',
        '#D1FAE5',
        '#D7F8F4',
        '#E7F5E9',
      ];

      // One-time random styles
      tiles.forEach((t) => {
        const jitter = () => (Math.random() * 5 - 2).toFixed(1) + '%';
        const rot = (Math.random() * 8 - 4).toFixed(1) + 'deg';
        t.style.setProperty('--x', jitter());
        t.style.setProperty('--y', jitter());
        t.style.setProperty('--rot', rot);
        t.style.zIndex = String(10 + Math.floor(Math.random() * 20));
        t.style.setProperty('--accent', accents[Math.floor(Math.random() * accents.length)]);
      });

      let lastBP = '';

      function layout() {
        const bp = getBP();
        if (bp === lastBP) return;
        lastBP = bp;

        const count = bpMax(bp);
        const slots = pickSlots(bp).slice(0, count);

        tiles.forEach((t, i) => {
          if (i < count) {
            const s = slots[i % slots.length];
            t.style.display = '';
            t.style.left = s.left + '%';
            t.style.top = s.top + '%';
          } else {
            t.style.display = 'none';
          }
        });
      }

      layout();
      window.addEventListener('resize', layout);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-benefit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.clean-benefits-section[data-section-id]');
    if (!section) return;

    const sectionId = section.getAttribute('data-section-id'); // Access the section id dynamically
    const animatedElements = section.querySelectorAll('.clean-animate');

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            } else {
              entry.target.classList.remove('is-visible');
            }
          });
        },
        {
          threshold: 0.1, // Triggers when 10% of the element is visible
        }
      );

      animatedElements.forEach((el) => {
        observer.observe(el);
      });
    } else {
      // Fallback for older browsers: just make everything visible at once
      animatedElements.forEach((el) => {
        el.classList.add('is-visible');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('.ethos-scroll-animate');

    if (!animatedElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('in-view', entry.isIntersecting);
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    animatedElements.forEach((el) => observer.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-comparision"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.why-welbewust__section');
    if (!section) return;

    const animated = Array.from(section.querySelectorAll('.why-animate'));

    // Stagger: 100ms, 200ms, ... set BEFORE observing
    animated.forEach((el, i) => {
      el.style.transitionDelay = `${(i + 1) * 100}ms`;
    });

    // If reduced motion, just show everything
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      animated.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target); // reveal once, don't toggle off later
          }
        });
      },
      { threshold: 0.1 }
    );

    animated.forEach((el) => io.observe(el));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-delivery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Use a class instead of an id with Liquid to keep JS static/theme-check safe
    const wrappers = document.querySelectorAll('.journey-video-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach((videoWrapper) => {
      const videoElement = videoWrapper.querySelector('video');

      if (videoElement) {
        videoWrapper.addEventListener(
          'click',
          () => {
            if (videoWrapper.classList.contains('video-is-playing')) return;
            videoWrapper.classList.add('video-is-playing');
            videoElement.play?.();
            videoElement.controls = true;
          },
          { passive: true }
        );
      }

      const sectionElement = videoWrapper.closest('.how-it-works-journey__section');
      if (!sectionElement) return;

      const stepsToAnimate = sectionElement.querySelectorAll(
        '.how-it-works-journey__timeline .how-it-works-journey__step'
      );
      if (!stepsToAnimate.length) return;

      // Stagger delays
      stepsToAnimate.forEach((step, index) => {
        step.style.transitionDelay = `${index * 150}ms`;
      });

      if (!('IntersectionObserver' in window)) {
        stepsToAnimate.forEach((s) => s.classList.add('is-visible'));
        return;
      }

      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // reveal once
          });
        },
        { threshold: 0.1 }
      );

      stepsToAnimate.forEach((step) => io.observe(step));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const PX_PER_SEC = 80; // ← adjust speed here (bigger = faster)

    function setMarqueeDurations(ctx = document) {
      ctx.querySelectorAll('.carousel-track.animate-scroll').forEach((track) => {
        // Track contains two identical halves; half = original content width.
        const halfWidth = track.scrollWidth / 2;
        if (halfWidth > 0) {
          const duration = halfWidth / PX_PER_SEC; // seconds
          track.style.setProperty('--marquee-duration', `${duration}s`);
        }
      });
    }

    // Initial and on resize/content changes
    const boot = (ctx = document) => setMarqueeDurations(ctx);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }

    // Recompute on resize
    let ro;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(() => setMarqueeDurations());
      document.querySelectorAll('.carousel-track-wrapper').forEach((w) => ro.observe(w));
    } else {
      window.addEventListener('resize', () => setMarqueeDurations(), { passive: true });
    }

    // Shopify Theme Editor dynamic loads (if applicable)
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supplement-index"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // --- Setup for Word-by-Word Animation + manual <br> marker ---
    const heading = document.querySelector('.hero-heading-animate');
    if (heading) {
      const raw = heading.textContent || '';
      // Split into tokens, where [[br]] or |br| becomes a line break
      const tokens = raw.replace(/\s+/g, ' ').trim().split(' ');

      const nodes = [];
      tokens.forEach((t, idx) => {
        if (t === '[[br]]' || t === '|br|') {
          nodes.push(document.createElement('br'));
        } else {
          const span = document.createElement('span');
          span.className = 'word-span';
          span.textContent = t;
          nodes.push(span);
        }
        // keep spaces between words (but not after <br>)
        const isBreak = t === '[[br]]' || t === '|br|';
        if (!isBreak && idx !== tokens.length - 1) nodes.push(document.createTextNode(' '));
      });

      heading.innerHTML = '';
      nodes.forEach((n) => heading.appendChild(n));

      // Stagger delays only on words
      const wordSpans = heading.querySelectorAll('.word-span');
      wordSpans.forEach((span, index) => {
        span.style.transitionDelay = `${index * 80}ms`;
      });
    }

    // --- Intersection Observer (unchanged) ---
    const sectionToAnimate = document.querySelector('.anim-on-scroll');
    if (sectionToAnimate) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add('is-visible');
            else entry.target.classList.remove('is-visible');
          });
        },
        { threshold: 0.2 }
      );
      observer.observe(sectionToAnimate);
    }

    // --- Parallax (unchanged) ---
    const videoBackground = document.querySelector('.hero-section .video-background');
    if (videoBackground) {
      window.addEventListener('scroll', function () {
        const y = window.pageYOffset;
        videoBackground.style.transform = `translateY(${y * 0.3}px)`;
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["symptoms"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Scope the observer to this specific section to avoid conflicts
    const section = document.querySelector('.shopify-section--recognition');
    if (!section) {
      return;
    }

    const animatedElements = section.querySelectorAll('.animate-on-scroll');
    if (animatedElements.length === 0) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
      }
    );

    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testkit-biological"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hubLayout = document.querySelector(`.neuro-hub[data-section-id] .hub-layout`);
    if (!hubLayout) return;
    const navItems = hubLayout.querySelectorAll('.hub-nav-item');
    const contentPanes = hubLayout.querySelectorAll('.hub-content-pane');
    function activateTab(tabNumber) {
      navItems.forEach((item) => {
        item.classList.toggle('active', item.dataset.tab === tabNumber);
      });
      contentPanes.forEach((pane) => {
        pane.classList.toggle('active', pane.dataset.tabContent === tabNumber);
      });
    }
    navItems.forEach((item) => {
      item.addEventListener('click', () => {
        activateTab(item.dataset.tab);
      });
    });
    activateTab('1');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testkit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.shopify-section--welbewust-whats-included');
    if (!section) {
      return;
    }
    const animatedElements = section.querySelectorAll('.animate-on-scroll');
    if (animatedElements.length === 0) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      {
        threshold: 0.2,
      }
    );
    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testkitcasestudy"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
    const animatedElements = document.querySelectorAll(`.dossier[data-section-id] .animate-on-scroll`);
    if (!animatedElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    animatedElements.forEach((el) => {
      observer.observe(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testkitwelbe"] && !Shopify.designMode) return;
  try {
    
    function initializePhilosophySection(container) {
    const cards = container.querySelectorAll('.philosophy-card');
    cards.forEach((card) => {
      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        card.style.setProperty('--mouse-x', `${x}px`);
        card.style.setProperty('--mouse-y', `${y}px`);
      });
    });

    const animatedElements = container.querySelectorAll('.animate-on-scroll');
    if (!animatedElements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    animatedElements.forEach((el) => observer.observe(el));
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sectionContainer = document.querySelector('.philosophy-section-wrapper[data-section-id]');
    if (sectionContainer) {
      initializePhilosophySection(sectionContainer);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    const sectionContainer = event.target.querySelector('.philosophy-section-wrapper[data-section-id]');
    if (sectionContainer) {
      initializePhilosophySection(sectionContainer);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["therapy-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const isRTL = () =>
      (document.documentElement.dir || getComputedStyle(document.documentElement).direction) === 'rtl';

    /* Normalize scrollLeft in RTL across browsers (negative/default/reverse) */
    const getRtlScrollType = (() => {
      let cached;
      return () => {
        if (cached) return cached;
        const outer = document.createElement('div');
        outer.dir = 'rtl';
        outer.style.width = '100px';
        outer.style.height = '100px';
        outer.style.overflow = 'scroll';
        outer.style.position = 'absolute';
        outer.style.top = '-9999px';

        const inner = document.createElement('div');
        inner.style.width = '200px';
        inner.style.height = '1px';
        outer.appendChild(inner);
        document.body.appendChild(outer);

        outer.scrollLeft = 0;
        if (outer.scrollLeft === 0) {
          outer.scrollLeft = 1;
          cached = outer.scrollLeft === 0 ? 'negative' : 'default';
        } else {
          cached = 'reverse';
        }

        document.body.removeChild(outer);
        return cached;
      };
    })();

    const getNormalizedScrollLeft = (el, rtl) => {
      if (!rtl) return el.scrollLeft;
      const t = getRtlScrollType();
      const { scrollLeft, scrollWidth, clientWidth } = el;
      if (t === 'negative') return -scrollLeft;
      if (t === 'reverse') return scrollWidth - clientWidth - scrollLeft;
      return scrollLeft; // 'default'
    };

    const rafThrottle = (fn) => {
      let pending = false;
      return (...args) => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => {
          pending = false;
          fn(...args);
        });
      };
    };

    // Load GSAP (once) → Promise
    let gsapPromise;
    const ensureGSAP = () => {
      if (window.gsap) return Promise.resolve(window.gsap);
      if (!gsapPromise) {
        gsapPromise = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
          s.async = true;
          s.onload = () => resolve(window.gsap);
          s.onerror = reject;
          document.head.appendChild(s);
        });
      }
      return gsapPromise;
    };

    const setAriaSelected = (el, on) => {
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
      el.setAttribute('tabindex', on ? '0' : '-1');
      // Optional: reflect in DOM for CSS hooks
    };

    /* ---------- indicator start (inline-start) in px ---------- */
    const indicatorStartPx = (tab, tablist) => {
      const rtl = isRTL();
      const norm = getNormalizedScrollLeft(tablist, rtl);
      if (!rtl) {
        // distance from left edge minus how much scrolled from left
        return tab.offsetLeft - norm;
      }
      // distance from RIGHT edge minus how much scrolled from right
      const contentFromRight = tablist.scrollWidth - (tab.offsetLeft + tab.offsetWidth);
      return contentFromRight - norm;
    };

    /* ─────────── Intro (GSAP) animation ─────────── */
    const runIntroAnimation = async (root) => {
      if (mqReduced.matches) return;
      const gsap = await ensureGSAP().catch(() => null);
      if (!gsap) return;

      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      const img = root.querySelector('.therapyMedia img');
      const circle = root.querySelector('.circle.rotating');
      const tabs = root.querySelectorAll('.tabs .tab');
      const h2 = root.querySelector('.section-header h2');
      const sub = root.querySelector('.section-header .sub');
      const lead = root.querySelector('.section-header .lead');
      const ctas = root.querySelector('.cta-row');
      const indicator = root.querySelector('.tabs__indicator');
      const chips = root.querySelectorAll('.chip');

      img && gsap.set(img, { opacity: 0, filter: 'blur(10px)' });
      circle && gsap.set(circle, { opacity: 0, scale: 0.96 });
      tabs.length && gsap.set(tabs, { opacity: 0, y: 12 });
      h2 && gsap.set(h2, { opacity: 0, y: 18 });
      sub && gsap.set(sub, { opacity: 0, y: 16 });
      lead && gsap.set(lead, { opacity: 0, y: 16 });
      ctas && gsap.set(ctas, { opacity: 0, y: 14 });
      chips.length && gsap.set(chips, { opacity: 0, y: 10 });
      indicator && gsap.set(indicator, { opacity: 0 });

      img && tl.to(img, { opacity: 1, filter: 'blur(0px)', duration: 0.9 }, 0.0);
      circle && tl.to(circle, { opacity: 1, scale: 1, duration: 0.7 }, 0.05);
      tabs.length && tl.to(tabs, { opacity: 1, y: 0, duration: 0.45, stagger: 0.06 }, 0.12);
      h2 && tl.to(h2, { opacity: 1, y: 0, duration: 0.6 }, '-=0.2');
      sub && tl.to(sub, { opacity: 1, y: 0, duration: 0.5 }, '-=0.35');
      lead && tl.to(lead, { opacity: 1, y: 0, duration: 0.55 }, '-=0.32');
      ctas && tl.to(ctas, { opacity: 1, y: 0, duration: 0.5 }, '-=0.25');
      indicator && tl.to(indicator, { opacity: 1, duration: 0.25 }, '-=0.35');
      chips.length && tl.to(chips, { opacity: 1, y: 0, duration: 0.45, stagger: 0.08 }, '-=0.2');
    };

    /* ─────────── Tabs: state + indicator + copy swap ─────────── */
    const mountTabs = (root) => {
      const tablist = root.querySelector('[data-tabs]');
      const indicator = tablist?.querySelector('.tabs__indicator');
      const tabs = tablist ? Array.from(tablist.querySelectorAll('.tab')) : [];
      const host = root.querySelector('.copy-frames');

      if (!tablist || !indicator || !tabs.length || !host) return;

      const frames = Array.from(host.querySelectorAll('.copy-frame'));

      const swapCopy = (idx) => {
        const incoming = frames[idx];
        const current = frames.findIndex((f) => f.classList.contains('is-active'));
        const outgoing = frames[current];
        if (!incoming || incoming === outgoing) return;

        const toggle = () => {
          if (outgoing) {
            outgoing.classList.remove('is-active');
            outgoing.hidden = true;
            outgoing.setAttribute('aria-hidden', 'true');
          }
          incoming.hidden = false;
          incoming.classList.add('is-active');
          incoming.setAttribute('aria-hidden', 'false');
          host.style.height = incoming.scrollHeight + 'px';
        };

        if (!mqReduced.matches && window.gsap) {
          const gsap = window.gsap;
          const rtl = isRTL();
          const fromX = rtl ? 48 : -48; // ← flip direction in RTL
          const toX = 0;
          const outX = rtl ? -48 : 48; // ← flip direction in RTL

          const fromH = host.offsetHeight || (outgoing ? outgoing.scrollHeight : incoming.scrollHeight);
          gsap.set(host, { height: fromH });

          incoming.hidden = false;
          incoming.setAttribute('aria-hidden', 'false');
          gsap.set(incoming, { x: fromX, opacity: 0, filter: 'blur(6px)' });

          const toH = incoming.scrollHeight;
          toH && gsap.to(host, { height: toH, duration: 0.3, ease: 'power2.out' });

          outgoing &&
            gsap.to(outgoing, {
              x: outX,
              opacity: 0,
              filter: 'blur(6px)',
              duration: 0.24,
              ease: 'power2.out',
              onComplete() {
                outgoing.classList.remove('is-active');
                outgoing.hidden = true;
                outgoing.setAttribute('aria-hidden', 'true');
                gsap.set(outgoing, { clearProps: 'x,filter' });
              },
            });

          incoming.classList.add('is-active');
          gsap.to(incoming, {
            x: toX,
            opacity: 1,
            filter: 'blur(0px)',
            duration: 0.3,
            ease: 'power3.out',
            onComplete() {
              gsap.set(incoming, { clearProps: 'x,filter' });
            },
          });
        } else {
          toggle();
        }
      };

      const updateIndicator = (idx) => {
        const t = tabs[idx];
        if (!t) return;

        const rtl = isRTL();

        const startX = indicatorStartPx(t, tablist);

        const tb = tablist.getBoundingClientRect();
        const rb = t.getBoundingClientRect();
        const cs = getComputedStyle(tablist);
        const padTop = parseFloat(cs.paddingTop) || 0;
        const borderTop = parseFloat(cs.borderTopWidth) || 0;

        const y = -5;
        const h = rb.height;
        const w = rb.width;

        const xVal = rtl ? -startX : startX;
        window.gsap && !mqReduced.matches
          ? window.gsap.to(indicator, { x: xVal, y, width: w, height: h, duration: 0.35, ease: 'power3.out' })
          : ((indicator.style.transform = `translate(${xVal}px, ${y}px)`),
            (indicator.style.width = w + 'px'),
            (indicator.style.height = h + 'px'));
      };

      const setActive = (idxOrEl) => {
        const idx = typeof idxOrEl === 'number' ? idxOrEl : Math.max(0, tabs.indexOf(idxOrEl));
        const safe = Math.max(0, Math.min(idx, tabs.length - 1));
        tabs.forEach((btn, i) => setAriaSelected(btn, i === safe));
        swapCopy(safe);
        requestAnimationFrame(() => updateIndicator(safe));
      };

      // click + keyboard
      tabs.forEach((btn, i) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          setActive(i);
        });
        btn.addEventListener('keydown', (e) => {
          const current = tabs.indexOf(document.activeElement);
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            tabs[(current + 1) % tabs.length].focus();
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            tabs[(current - 1 + tabs.length) % tabs.length].focus();
          }
          if (e.key === 'Home') {
            e.preventDefault();
            tabs[0].focus();
          }
          if (e.key === 'End') {
            e.preventDefault();
            tabs[tabs.length - 1].focus();
          }
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setActive(tabs.indexOf(document.activeElement));
          }
        });
      });

      // initial state
      setActive(0);
      const activeFrame = host.querySelector('.copy-frame.is-active') || frames[0];
      if (activeFrame) host.style.height = activeFrame.scrollHeight + 'px';

      // Resize & horizontal scroll keep indicator aligned
      const onResize = rafThrottle(() => {
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            const i = tabs.findIndex((t) => t.classList.contains('is-active'));
            updateIndicator(i >= 0 ? i : 0);
          });
        }
        updateIndicator(i >= 0 ? i : 0);
        const a = host.querySelector('.copy-frame.is-active');
        if (a) host.style.height = a.scrollHeight + 'px';
      });
      const onScroll = rafThrottle(() => {
        const i = tabs.findIndex((t) => t.classList.contains('is-active'));
        updateIndicator(i >= 0 ? i : 0);
      });

      window.addEventListener('resize', onResize, { passive: true });
      tablist.addEventListener('scroll', onScroll, { passive: true });

      // disposer
      return () => {
        window.removeEventListener('resize', onResize);
        tablist.removeEventListener('scroll', onScroll);
      };
    };

    /* ─────────── Boot sections ─────────── */
    const mountHero = (root) => {
      const cleanup = [];
      const disposer = mountTabs(root);
      disposer && cleanup.push(disposer);

      ensureGSAP()
        .then(() => runIntroAnimation(root))
        .catch(() => {});
      return () =>
        cleanup.forEach((fn) => {
          try {
            fn();
          } catch {}
        });
    };

    try {
      document.documentElement.classList.add('js');
    } catch {}

    const mountAll = (scope) => {
      (scope.querySelectorAll?.('.therapy-hero') || []).forEach((el) => {
        if (el.__heroDispose) el.__heroDispose();
        el.__heroDispose = mountHero(el);
      });
    };

    document.addEventListener('DOMContentLoaded', () => mountAll(document));
    document.addEventListener('shopify:section:load', (e) => mountAll(e.target));
    document.addEventListener('shopify:section:unload', (e) => {
      (e.target.querySelectorAll?.('.therapy-hero') || []).forEach((el) => {
        el.__heroDispose && el.__heroDispose();
        el.__heroDispose = null;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.section-container');
    const cards = document.querySelectorAll('.section-container .card');
    const tags = document.querySelectorAll('.therapy-tags .tag');

    // Bail if missing essentials
    const { gsap, ScrollTrigger } = window;
    if (!section || !gsap || !ScrollTrigger || !cards.length) return;

    gsap.registerPlugin(ScrollTrigger);

    // Respect reduced motion; only animate on desktop (≥1024px)
    const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isDesktop = matchMedia('(min-width:1024px)').matches;
    if (prefersReduced || !isDesktop) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 80%',
        once: true,
      },
    });

    // Staggered card reveals from alternating directions
    const dirs = [
      { x: -60, y: 0 }, // left
      { x: 60, y: 0 }, // right
      { x: 0, y: -60 }, // up
      { x: 0, y: 60 }, // down
    ];

    cards.forEach((card, i) => {
      const d = dirs[i & 3]; // i % 4, faster
      tl.from(card, { ...d, opacity: 0, duration: 0.6, ease: 'power2.out' }, i * 0.08);
    });

    // Tag fade-up after cards start
    if (tags.length) {
      tl.from(tags, { opacity: 0, y: 14, duration: 0.4, stagger: 0.08, ease: 'power2.out' }, '-=0.2');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welpsy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wrapper = document.querySelector('.psychology-bridge-wrapper');
    if (!wrapper) return;

    const targets = wrapper.querySelectorAll('[data-scroll-animate]');
    if (!targets.length) return;

    // Fallback if IntersectionObserver isn't supported
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { root: null, threshold: 0.12 }
    );

    targets.forEach((el) => io.observe(el));

    // Clean up in Theme Editor when section is removed
    document.addEventListener('shopify:section:unload', (e) => {
      if (e.target && e.target.contains(wrapper)) io.disconnect();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
